import { ListResponse } from "../../model/common/ListResponse";
import {
  SettlementConfirmRequestBody,
  SettlementDto,
  SettlementSummaryDto,
} from "../../model/Settlement";
import { axiosUtils } from "../../network/axiosUtils";
import httpRequest from "../../network/httpRequest";
import { SettlementListSearchQuery } from "./types";

const url = "/repair-shop-fee-settlements";

export const fetchSettlements = async (
  queryParams: SettlementListSearchQuery
): Promise<ListResponse<SettlementDto>> => {
  const response = await httpRequest({
    method: axiosUtils.GET,
    url,
    queryParams,
  });

  return response?.data;
};

export const fetchSettlementSummary = async (
  queryParams: SettlementListSearchQuery
): Promise<SettlementSummaryDto> => {
  const response = await httpRequest({
    method: axiosUtils.GET,
    url: `${url}/summary`,
    queryParams,
  });

  return response?.data.row;
};

export const updateSettlementConfirm = async (
  requestBody: SettlementConfirmRequestBody
): Promise<SettlementSummaryDto> => {
  const response = await httpRequest({
    method: axiosUtils.PUT,
    url: `${url}/confirm-settlement`,
    requestBody,
  });

  return response?.data.row;
};
